export default __webpack_public_path__ + "static/media/gruapluma.aebb2cee.jpg";